import React, { createContext, useContext, useState, useEffect } from 'react';

const PermissionsContext = createContext();

export const usePermissions = () => {
    return useContext(PermissionsContext);
};

export const PermissionsProvider = ({ children, initialPermissions }) => {
    // Array de permisos, o string 'ALL' para el admin
    const [permissions, setPermissions] = useState(initialPermissions || []);

    useEffect(() => {
        if (initialPermissions) {
            setPermissions(initialPermissions);
        }
    }, [initialPermissions]);

    // Verifica si el usuario tiene un permiso específico por nombre o ID
    const hasPermission = (permissionToCheck) => {
        if (permissions === 'ALL') return true;
        if (!permissions || !Array.isArray(permissions)) return false;

        return permissions.some(p =>
            p.name === permissionToCheck || p.id === permissionToCheck
        );
    };

    // Obtener el ID de un permiso dado su nombre
    const getPermissionId = (permissionName) => {
        if (permissions === 'ALL') return null; // Admin no necesita IDs
        const perm = permissions.find(p => p.name === permissionName);
        return perm ? perm.id : null;
    };

    return (
        <PermissionsContext.Provider value={{ permissions, hasPermission, getPermissionId }}>
            {children}
        </PermissionsContext.Provider>
    );
};
